'use strict'

aiAds = require '../../../ads/frontend/ai_ads'

module.exports = Backbone.View.extend

  render: (cardsHtml, aiAdsHash) ->
    @$el.html(cardsHtml)
    aiAds.refresh(aiAdsHash)

  append: (cardsHtml) ->
    @$el.append(cardsHtml)

  insertAfter: (cardsHtml, $card) ->
    $card.after(cardsHtml)
